/*
 * @Description: 
 * @Author: wjx
 * @Github: 
 * @LastEditors: jml
 * @Date: 2019-01-15 17:21:40
 * @LastEditTime: 2022-01-21 15:38:35
 */
import request from '@/utils/request'
const baseUrl = '/rest/channel/pc';

// 录播课详情页
export const recordCourseDetail = (data) => request({
  url: '/rest/course/recordCourseDetail',
  method: 'post',
  data
})
// 直播课详情页
export const livingCourseDetail = (data) => request({
  url: '/rest/course/livingCourseDetail',
  method: 'post',
  data
})
// 报名
export const signUp = (data) => request({
  url: '/rest/course/signUp',
  method: 'post',
  data
})
// 签到
export const signIn = (data) => request({
  url: '/rest/course/signIn',
  method: 'post',
  data
})
export const sendGift = (data) => request({
  url: '/rest/course/sendFlower',
  method: 'post',
  data
})
export const commentList = (data) => request({
  url: '/rest/course/commentList',
  method: 'post',
  data
})
export const sendComment = (data) => request({
  url: '/rest/course/comment',
  method: 'post',
  data
})
// 直播详情-获得分享邀请卡列表
export const queryLiveShareList = (data) => request({
  url: `${baseUrl}/liveBroadShare/queryLiveShareList`,
  method: 'post',
  data
})
// 查询观看限制信息
export const queryViewingCheckInfo = (data) => request({
  url: `${baseUrl}/liveBroadShare/queryViewingCheckInfo`,
  method: 'post',
  data
})
// 直播视频信息列表
export const querychannelCourseList = (data) => request({
  url: `${baseUrl}/channelCourse/querychannelCourseList`,
  method: 'post',
  data
})
// 直播详情-自定义菜单查询
export const queryliveZdyMenuList = (data) => request({
  url: `${baseUrl}/liveBroadZdyMenu/queryliveZdyMenuList`,
  method: 'post',
  data
})
// 详情页-获得关联多流接口
export const getCourseRela = (data) => request({
  url: `${baseUrl}/liveBroadZdyMenu/getCourseRela`,
  method: 'post',
  data
})
// 详情
export const courseDetail = (data) => request({
  url: `${baseUrl}/contentManage/courseDetail`,
  method: 'post',
  data
})
// 根据直播id、专区id查询是否有抽奖
export const queryChannelZhiboRaffle = (data) => request({
  url: `${baseUrl}/liveBroadZdyMenu/queryChannelZhiboRaffle`,
  method: 'post',
  data
})
// 提交观看限制问卷
export const saveViewingCheckInfoAnswer = (data) => request({
  url: `${baseUrl}/liveBroadShare/saveViewingCheckInfoAnswer`,
  method: 'post',
  data
})
// 直播详情-根据专区id和课程id查询直播配置信息 活动
export const queryChannelZhiboConf = (data) => request({
  url: `${baseUrl}/liveBroadZdyMenu/queryChannelZhiboConf`,
  method: 'post',
  data
})
// 直播详情-根据专区id和课程id查询直播白名单配置
export const isZhiboWhite = (data) => request({
  url: `${baseUrl}/channelZhiboWhite/isZhiboWhite`,
  method: 'post',
  data
})
// 直播详情-查询课程信息
export const queryChannelCourse = (data) => request({
  url: `${baseUrl}/liveBroadZdyMenu/queryChannelCourse`,
  method: 'post',
  data
})
// 直播详情-根据传入抽奖id、用户id 获得抽奖结果
export const queryDrawResults = (data) => request({
  url: `${baseUrl}/liveBroadShare/queryDrawResults`,
  method: 'post',
  data
})
// 直播详情-分享直播课
export const queryLiveShareCourseList = (data) => request({
  url: `${baseUrl}/liveBroadShare/queryLiveShareCourseList`,
  method: 'post',
  data
})
// 查询该用户是否已经提交过限制问卷答案
export const queryUserInfoAnswer = (data) => request({
  url: `${baseUrl}/liveBroadShare/queryUserInfoAnswer`,
  method: 'post',
  data
})
// 提交保存中奖人信息
export const saveraffleWinnerInfo = (data) => request({
  url: `${baseUrl}/liveBroadShare/saveraffleWinnerInfo`,
  method: 'post',
  data
})
// 查询奖品信息
export const queryCourseRaffleConfigInfo = (data) => request({
  url: `${baseUrl}/liveBroadZdyMenu/queryCourseRaffleConfigInfo`,
  method: 'post',
  data
})
// 查询判断用户是否已抽奖
export const queryCheckZhiboRaffleInfi = (data) => request({
  url: `${baseUrl}/liveBroadZdyMenu/queryCheckZhiboRaffleInfi`,
  method: 'post',
  data
})
// 问卷查询
export const questionnaireList = (data) => request({
  url: `${baseUrl}/liveBroadZdyMenu/questionnaireList`,
  method: 'post',
  data
})
// 搜索有内容的菜单
export const querychannelCourseMenuInfo = (data) => request({
  url: `${baseUrl}/channelCourse/querychannelCourseMenuInfo`,
  method: 'post',
  data
})